var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toast-box flex"},[_c('img',{staticClass:"toast__icon",attrs:{"src":require("../../assets/png/toast-success.png")}}),_c('div',[_c('h1',{staticClass:"toast__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('span',{staticClass:"toast__text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }